import { durationToUnit } from '@ryki/datemath'

export default {
    boolean: (value) => value,
    text: (value) => (value ? String(value).toLowerCase() : ''),
    number: (value) => value ?? -Infinity,
    currency: (value) => value ?? -Infinity,
    percent: (value) => value ?? -Infinity,
    durationMinutes: (value) => value ?? -Infinity,
    date: (value) =>
        value instanceof Date && !isNaN(value) ? value?.getTime() : -Infinity,
    duration: (value) =>
        value?.value && value?.unit
            ? durationToUnit(value, 'milliseconds')
            : -Infinity,
    progress: (value) =>
        value?.denominator ? value.numerator / value.denominator : -Infinity,
    progressBar: (value) =>
        value?.denominator ? value.numerator / value.denominator : -Infinity,
    project: (value) => value?.title ?? '',
    phase: (value) => value?.title ?? '',
    costCentre: (value) => value?.name ?? '',
    contact: (value) => value?.label ?? '',
    staff: (value) => value?.fullName ?? '',
    staffMember: (value) => value?.fullName ?? '',
    role: (value) => value?.name ?? '',
    status: (value) => value ?? '',
}
